exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lf-add .device-image{width:100%;margin-bottom:16px}.lf-add .page-information{padding:4px 8px!important;background-color:#f3f3f3;border:1px solid #e6e6e6;margin-bottom:16px}.lf-add .button-container{margin-bottom:12px}.lf-add .button-container .md-button{margin:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader!../~/sass-loader!./components/lf-add/lf-add.scss
// module id = 135
// module chunks = 0